import Login from "./Login";
import Register from "./Register";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Logo2 from "../../assets/logo2.png"

export default function AuthModal({
  show,
  onHide,
  tab,
  setTab,
  onLoginSuccess,
  imageSrc,
}) {
  const sideImage = imageSrc || "/images/auth-side.jpg"; // byt till din egen path

  return (
    <Dialog
      open={show}
      onClose={onHide}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            minHeight: { md: 380, xs: "auto" },
          }}
        >
          {/* VÄNSTER: bild */}
          <Box
            sx={{
              flexBasis: { md: "45%", xs: "100%" },
              display: { xs: "none", md: "block" },
            }}
          >
            <Box
              component="img"
              src={sideImage}
              alt="Login illustration"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>

          {/* HÖGER: header + tabs + formulär */}
          <Box
            sx={{
              flexBasis: { md: "55%", xs: "100%" },
              p: 4, 
              display: "flex",
              flexDirection: "column",
         
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 1,
              }}
            >
              <DialogTitle
                sx={{
                  p: 0,
                  fontSize: 30,
                  fontWeight: 700,
                }}
              >
              <img src={Logo2} className="auth-logo" alt="" />
              </DialogTitle>

              <IconButton
                edge="end"
                onClick={onHide}
                size="small"
                aria-label="Stäng"
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Tabs
              value={tab}
              onChange={(_, value) => setTab(value)}
              centered
              slotProps={{
                indicator: {
                  sx: {
                    backgroundColor: "accent.main",
                    height: 3,
                    borderRadius: 2,
                    transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1)",
                  },
                },
              }}
              sx={{
                mt: 5,
                mb: 2,
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: 15,
                  color: "#777",
                  minHeight: 40,
                  paddingInline: 2,
                  backgroundColor: "transparent !important",
                  "&:hover": { backgroundColor: "transparent" },
                  "&.Mui-focusVisible": {
                    backgroundColor: "transparent",
                  },
                  "&:active": { backgroundColor: "transparent" },
                },
                "& .Mui-selected": {
                  color: "primary.main",
                },
              }}
            >
              <Tab
                label="Logga in"
                value="login"
                disableRipple
                disableFocusRipple
              />
              <Tab
                label="Registrera"
                value="register"
                disableRipple
                disableFocusRipple
              />
            </Tabs>

            {/* smooth crossfade mellan login / register */}
            <Box
              sx={{
                position: "relative",
                flex: 1,
                minHeight: 260,
                mt: 1,
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  opacity: tab === "login" ? 1 : 0,
                  pointerEvents: tab === "login" ? "auto" : "none",
                  transition: "opacity 200ms ease",
                }}
              >
                <Login onLoginSuccess={onLoginSuccess} />
              </Box>

              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  opacity: tab === "register" ? 1 : 0,
                  pointerEvents: tab === "register" ? "auto" : "none",
                  transition: "opacity 200ms ease",
                }}
              >
                <Register onRegistered={() => setTab("login")} />
              </Box>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
